import { useContext } from "react";

import { AuthAppContext } from "components/root/auth-app-provider";
import { type NotificationName } from "components/shared/notifications/notifications";
import { CoverageContext } from "pages/overview/extended-coverages/hooks";

export const useShowHomeServicesAlert = (
  availableNotifications: NotificationName[]
) => {
  return availableNotifications.includes("HomeServices");
};

export const useShowCancellationPaymentNotice = (
  availableNotifications: NotificationName[]
) => {
  return availableNotifications.includes("CancellationPayment");
};

export const useShowCoverageNotification = (
  availableNotifications: NotificationName[]
) => {
  const { coveragePage } = useContext(CoverageContext);
  const { selectedPolicyId } = useContext(AuthAppContext);

  return (
    availableNotifications.includes("Coverage") &&
    coveragePage?.type &&
    selectedPolicyId === coveragePage.policyId
  );
};
